/**
 * 磋商状态枚举
 */
export enum ConsultationStatus {
  /** 未磋商 */
  NOT_CONSULTED = 1,
  /** 磋商中 */
  IN_PROGRESS = 2,
  /** 磋商完成 */
  COMPLETED = 3
}

/**
 * 前端磋商记录展示状态（Normalized*ConsultationRecord.status）
 *
 * 与后端 ConsultationStatus（数字）不同：这里是对外展示用的字符串字面量，
 * 用于 6 个 `*-consultation-records.ts` 工具与对应的 ConsultationHistorySection 模板统一引用，
 * 避免字面量散落多处。
 */
export const CONSULTATION_RECORD_STATUS = {
  /** 磋商中（对应 ConsultationStatus.IN_PROGRESS 的最新一条） */
  CONSULTING: 'consulting',
  /** 已回复 */
  REPLIED: 'replied'
} as const

/** 磋商记录展示状态字面量类型 */
export type ConsultationRecordStatus = typeof CONSULTATION_RECORD_STATUS[keyof typeof CONSULTATION_RECORD_STATUS]

